import { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import Button from "../../../components/Button";
import { Reconciliation } from "../../../api/types";
import usePostReconciliation from "../../../api/usePostReconciliation";
import { typedSxMap } from "../../../utils/typedSxMap";
import style from "../../forms/style/Form.module.scss";

type CompleteReconciliationModalProps = {
  reconciliation?: Reconciliation;
  onSuccess: () => void;
  onClose: () => void;
};

const styles = typedSxMap({
  actionButtons: {
    display: "flex",
    gap: "var(--m)",
    justifyContent: "flex-end",
    marginTop: "var(--m)",
  },
});

export default function CompleteReconciliationForm({ reconciliation, onSuccess, onClose }: CompleteReconciliationModalProps) {
  const { mutate, isLoading, isSuccess } = usePostReconciliation(reconciliation?.workspace_id);

  const onCompleteConfirm = () => {
    mutate({
      id: reconciliation?.id || "",
      status: "complete",
    });
  };

  useEffect(() => {
    if (isSuccess && onSuccess) {
      onSuccess();
    }
  }, [isSuccess]);

  return (
    <div className={style.container}>
      <div className={style.title}>
        <h2>Mark Complete</h2>
      </div>
      <p>Are you sure you want to mark this reconciliation as complete?</p>
      <fieldset disabled={isLoading}>
        <Box sx={styles.actionButtons}>
          <Button type="button" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variants={["primary"]} type="button" onClick={onCompleteConfirm} disabled={isLoading}>
            Mark Complete
          </Button>
        </Box>
      </fieldset>
    </div>
  );
}
